export { default as FooterContentInjector } from './FooterContentInjector';
export { default as Footer } from './NonstaticFooter';
export { default as NonstaticFooterLegal } from './NonstaticFooterLegal';
export { default as NonstaticSitemap } from './NonstaticSitemap';
export { default as StaticFooter } from './StaticFooter';
export { default as StaticFooterLegal } from './StaticFooterLegal';
export { default as StaticSitemap } from './StaticSitemap';